import { OptionValue } from "@bluframe/blublocks"
import prepareComponent from "@bluframe/grapple/prepareComponent"
import {
  HomeVideo,
  Image,
  NewsServiceName,
  ReviewsServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { RefObject, useRef } from "react"

import Draft from "./Draft"

export interface DraftPreview {
  image?: string
  name: NewsServiceName | ReviewsServiceName | string
  releaseDate?: string
  url: string
}

export interface Props {
  hasAdditionalInstructions?: boolean
  homeVideo?: HomeVideo
  id: string
  image?: Image
  isAdmin?: boolean
  isChecked: boolean
  isEditor?: boolean
  isGenerateLoading?: boolean
  isPublishLoading: boolean

  onChange: (value: OptionValue) => void

  onView?: (id: string) => void
  onGenerate?: (
    id: string,

    overrides?: {
      additionalInstructions: string | undefined
    }
  ) => void
  onPublish: (
    id: string,

    overrides?: {
      additionalInstructions: string | undefined
    }
  ) => void
  previews: DraftPreview[]
  title: string
}

export interface ComponentProps extends Omit<
  Props,
  "onView" | "onGenerate" | "onPublish"
> {
  onView?: () => void
  onGenerate?: () => void
  onPublish: () => void
  textAreaRef: RefObject<HTMLTextAreaElement | null>
}

const usePrepareComponent = (props: Props): ComponentProps => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  const onView = props.onView
    ? () => {
        props.onView?.(props.id)
      }
    : undefined

  const onGenerate = props.onGenerate
    ? () => {
        props.onGenerate?.(
          props.id,
          textAreaRef.current?.value
            ? { additionalInstructions: textAreaRef.current?.value }
            : undefined
        )
      }
    : undefined

  const onPublish = () => {
    props.onPublish(
      props.id,
      textAreaRef.current?.value
        ? { additionalInstructions: textAreaRef.current?.value }
        : undefined
    )
  }

  return {
    ...props,
    onGenerate,
    onPublish,
    onView,
    textAreaRef
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Draft
)
